const prefix = (type) => `eureka/invites/${type}`;

export const DELETE_INVITE_START = prefix('DELETE_INVITE_START');
export const DELETE_INVITE_SUCCESS = prefix('DELETE_INVITE_SUCCESS');
export const DELETE_INVITE_FAILED = prefix('DELETE_INVITE_FAILED');
